import React from 'react';
import { useTheme } from 'styled-components';
import { Flex } from '@ui-library/flex';
import { XMark } from '@ui-library/icons';
import { BaseText, SmallText } from '@ui-library/typography';
import { Button } from '@ui-library/button';
import { StyledHeader } from './styles';

interface DrawerHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  onClose: () => void;
  children?: React.ReactNode;
}

const DrawerHeader = ({ title, subtitle, onClose, children }: DrawerHeaderProps) => {
  const theme = useTheme();

  return (
    <StyledHeader>
      <Flex justifyContent="space-between" alignItems="center">
        <BaseText fontWeight={500}>{title}</BaseText>
        <Button
          variant="next"
          level="tertiary"
          size="small"
          icon={<XMark />}
          onClick={onClose}
          aria-label="Close drawer"
        />
      </Flex>
      {subtitle && <SmallText color={theme.token.next.palette.grey500}>{subtitle}</SmallText>}
      {children}
    </StyledHeader>
  );
};

export { DrawerHeader };
